/* Cloud home page behaviour, ported into Horizon.
   Loaded once from layout/theme.liquid (guarded to the index template).
   The header is burger + centred wordmark + cloud cart; navigation lives in the drawer. */
/* --z  tier-3 canvas scale (1101–1427)
     --pz mobile scale for the two non-unwindable artwork compositions
     --bw background bleed scale: 1 up to 1428, then grows so the photo layers
          reach the viewport edges while the content canvas stays at 1428 */
  function fit() {
    var d = document.documentElement, w = d.clientWidth;
    /* Content is capped at MAXW. The canvas is authored at 1428, so it is zoomed by
       MAXW/1428 once the viewport can fit it; below that it scales with the viewport.
       zoom changes the layout width to w/z, so backgrounds (sized 1428 * --bw) need
       --bw = (w / z) / 1428, which reduces to w / MAXW. */
    var MAXW = 1229, DESIGN = 1428;
    var z = 1, bw = 1;
    if (w > 1100) {
      z  = Math.min(w, MAXW) / DESIGN;
      bw = Math.max(1, w / MAXW);
    }
    d.style.setProperty('--z', z);
    d.style.setProperty('--bw', bw);
    var pad = 2 * Math.min(44, Math.max(20, w * 0.055));
    d.style.setProperty('--pz', w <= 1100 ? Math.min(1, (w - pad) / DESIGN) : 1);
    /* the drawer canvas is authored at 582x1377. Scale by whichever axis is tighter so
       the whole menu fits the screen at once instead of overflowing and scrolling. */
    var vh = innerHeight || d.clientHeight;
    /* panel width: 40vw on desktop, 88vw on mobile. The canvas inside is authored at
       582 wide x 1377 tall, so --mz is the smaller of the two fits — width, or the
       viewport height, so the whole menu is reachable without scrolling. */
    /* Panel width: 40% of the viewport on desktop, 88% on mobile. The body carries
       `zoom`, and a fixed element inside a zoomed context is scaled by it too — so
       40vw of CSS renders at 40vw * z. Dividing by z here makes the RENDERED width
       a true 40%. The canvas inside is 582x1377, so --mz is the smaller of the
       width fit and the height fit, both in the same unzoomed space. */
    var menuW = (w > 1100 ? w * 0.40 : w * 0.88) / z;
    d.style.setProperty('--menu-w', menuW + 'px');
    /* width-driven only. The panel's CSS width is calc(582px * --mz), so this makes
       the panel exactly menuW wide — a true 40% once the body zoom is applied. A
       height fit here would shrink the canvas and drag the panel narrow with it;
       the panel is inset:0 (full height) and scrolls instead. */
    d.style.setProperty('--mz', menuW / 582);
    /* the mobile hero is authored on Figma's own 456-wide canvas (Frame 497), so it
       scales to the viewport exactly like the 1428 desktop canvas does */
    d.style.setProperty('--hz', w <= 1100 ? w / 456 : 1);
  }
  fit();
  addEventListener('resize', fit);
  /* `resize` alone is not enough. Every canvas variable above is derived from
     clientWidth, so if the layout width changes WITHOUT a window resize event the
     whole page keeps rendering at the previous width — most visibly the hero photo,
     which is a 456x700 box scaled by --hz: left stale it stops short of the right
     edge and the white canvas shows through as a hairline down the side of the site.
     That happens on a scrollbar appearing or disappearing as content loads, on
     bfcache restore, and on the mobile URL bar settling. A ResizeObserver on the root
     catches all of them because it watches the box itself rather than an event. */
  if (window.ResizeObserver) new ResizeObserver(fit).observe(document.documentElement);
  /* bfcache restores skip both of the above */
  addEventListener('pageshow', function (e) { if (e.persisted) fit(); });


  /* ---- 449 stat: count the figure up once, when it scrolls into view ----
     One-shot, not a loop. The markup ships the real value ("92%"), so with JS off or
     reduced-motion on, the correct number is already on screen — the animation only
     ever rewrites a value that is about to land back where it started. */
  (function () {
    var nums = [].slice.call(document.querySelectorAll('.ch-statnum'));
    if (!nums.length || !window.IntersectionObserver) return;
    if (matchMedia('(prefers-reduced-motion:reduce)').matches) return;

    function run(el) {
      var raw = (el.textContent || '').trim();
      var m = raw.match(/(\d[\d,.]*)/);
      if (!m) return;
      var target = parseFloat(m[1].replace(/,/g, ''));
      var prefix = raw.slice(0, m.index), suffix = raw.slice(m.index + m[1].length);
      /* 1200ms landed before the eye had settled on the box; 1900 lets the figure
         be read as it climbs without stalling the section. */
      var dur = 1900, t0 = null;
      function step(t) {
        if (t0 === null) t0 = t;
        var k = Math.min(1, (t - t0) / dur);
        var eased = 1 - Math.pow(1 - k, 3);          /* ease-out: fast, then settles */
        el.textContent = prefix + Math.round(target * eased) + suffix;
        if (k < 1) requestAnimationFrame(step);
        else el.textContent = raw;                    /* restore exactly what Liquid rendered */
      }
      requestAnimationFrame(step);
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);                       /* once only */
        run(e.target);
      });
    }, { threshold: 0.6 });
    nums.forEach(function (el) { io.observe(el); });
  })();

  /* ---- 448: hovering a product box nudges its label's arrow ----
     The hit region and the label are separate .frame children, so no CSS combinator
     reaches from one to the other — the class is mirrored across in JS instead. */
  (function () {
    var sec = document.querySelector('#cloud-products');
    if (!sec) return;
    [].forEach.call(sec.querySelectorAll('[data-cons]'), function (el) {
      var cons = el.getAttribute('data-cons');
      var label = sec.querySelector('.ch-prodlabel[data-cons="' + cons + '"]');
      if (!label) return;
      el.addEventListener('mouseenter', function () { label.classList.add('ch-hovered'); });
      el.addEventListener('mouseleave', function () { label.classList.remove('ch-hovered'); });
    });
  })();

  /* ---- 451 FAQ: animate the close, not just the open ----
     The markup uses <details name>, which gives a single-open accordion with no JS at
     all. The catch is that the UA removes `open` from the outgoing panel the instant
     another opens, so its height transition never runs and it snaps shut.
     So: drop the name (JS is present, so exclusivity can be ours), and on close keep
     `open` in place while a .ch-closing class drives the panel to its collapsed state.
     The attribute comes off only once the transition has finished. With JS off the
     name attribute is still in the markup and the native accordion behaves as before. */
  (function () {
    var list = document.querySelector('#cloud-faq .ch-faqlist');
    if (!list) return;
    var items = [].slice.call(list.querySelectorAll('.ch-faqitem'));
    if (!items.length) return;

    /* keep in step with the .58s grid-template-rows transition in cloud-home.css */
    var DUR = 580;
    if (matchMedia('(prefers-reduced-motion:reduce)').matches) DUR = 0;

    items.forEach(function (d) { d.removeAttribute('name'); });

    function close(d) {
      if (!d.hasAttribute('open') || d.classList.contains('ch-closing')) return;
      d.classList.add('ch-closing');
      setTimeout(function () {
        /* re-opened mid-close? then leave it alone */
        if (!d.classList.contains('ch-closing')) return;
        d.classList.remove('ch-closing');
        d.removeAttribute('open');
      }, DUR);
    }
    function open(d) {
      d.classList.remove('ch-closing');
      d.setAttribute('open', '');
    }

    list.addEventListener('click', function (e) {
      var sum = e.target.closest('.ch-faqq');
      if (!sum || !list.contains(sum)) return;
      e.preventDefault();                       /* the state is ours to set */
      var d = sum.parentNode;
      var isOpen = d.hasAttribute('open') && !d.classList.contains('ch-closing');
      items.forEach(function (o) { if (o !== d) close(o); });
      if (isOpen) close(d); else open(d);
    });
  })();

/* ---- cart icon → Horizon's cart drawer ----
     The drawer, its open/close logic and its focus handling all belong to the theme
     (snippets/cart-drawer.liquid + cart-drawer.js). Rather than reimplement any of
     that, our icon forwards the click to the drawer's own trigger button, so there is
     exactly one code path. The link falls back to /cart if the drawer isn't present
     (or JS hasn't run), which is why it stays an <a href> in the markup. */
  (function () {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-ch-cart-open]');
      if (!link) return;
      /* There are TWO drawers on this template: Horizon's header still renders one, and
         this template hides the header (#header-group{display:none}) — so that copy can
         never be shown. querySelector returns it first, which meant the drawer opened
         with a 0x0 box every time. Pick the one that is actually laid out. */
      var drawer = [].filter.call(document.querySelectorAll('cart-drawer-component'),
                                  function (d) { return d.getClientRects().length; })[0];
      var btn = drawer && drawer.querySelector('[data-testid="cart-drawer-trigger"]');
      if (!btn) return;                 /* no usable drawer — let /cart happen */
      e.preventDefault();
      btn.click();
    });

    /* keep our count in step: Horizon fires cart:update carrying the new item count */
    document.addEventListener('cart:update', function (e) {
      var n = e.detail && e.detail.data && e.detail.data.itemCount;
      if (typeof n !== 'number') return;
      [].forEach.call(document.querySelectorAll('.ch-cart-n'), function (el) { el.textContent = n; });
      [].forEach.call(document.querySelectorAll('[data-ch-cart-open]'), function (a) {
        a.setAttribute('aria-label', 'Cart, ' + n + ' item' + (n === 1 ? '' : 's'));
      });
    });
  })();

/* ---- menu drawer ----
     Replaces the old dropdown nav: the design has no desktop nav links at all, so the
     burger is now the only route into navigation and the drawer runs at every width.
     [hidden] is removed on first open so the panel is out of the a11y tree until used,
     then the .ch-on class drives the slide so the transition still runs. */
  (function () {
    var burger = document.getElementById('ch-burger');
    var menu   = document.getElementById('ch-menu');
    var scrim  = document.querySelector('.ch-menu-scrim');
    if (!burger || !menu || !scrim) return;

    var lastFocus = null;

    function setMenu(open) {
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      if (open) {
        lastFocus = document.activeElement;
        menu.hidden = false; scrim.hidden = false;
        /* force a reflow so the browser has a start value to transition from */
        void menu.offsetWidth;
        menu.classList.add('ch-on'); scrim.classList.add('ch-on');
        document.body.style.overflow = 'hidden';
        var x = menu.querySelector('.ch-menu-x'); if (x) x.focus();
      } else {
        menu.classList.remove('ch-on'); scrim.classList.remove('ch-on');
        document.body.style.overflow = '';
        /* keep it in the DOM until the slide-out finishes, then hide it again */
        setTimeout(function () {
          if (!menu.classList.contains('ch-on')) { menu.hidden = true; scrim.hidden = true; }
        }, 440);
      }
    }
    function isOpen() { return burger.getAttribute('aria-expanded') === 'true'; }

    burger.addEventListener('click', function (e) { e.stopPropagation(); setMenu(!isOpen()); });

    /* the scrim and the ✕ both carry data-ch-menu-close */
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-ch-menu-close]')) { setMenu(false); if (lastFocus) lastFocus.focus(); }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) { setMenu(false); if (lastFocus) lastFocus.focus(); }
    });

    /* choosing a destination closes */
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a')) setMenu(false);
    });
  })();

  /* ---- 449 consistency: hovering a 448 product label crossfades the variant ----
     Desktop only; on mobile both panels are in flow so there is nothing to switch.
     The choice is sticky (no revert on mouseout) to avoid flicker. */
  (function () {
    var stack = document.querySelector('.ch-v449stack');
    if (!stack) return;
    var panels = {};
    [].forEach.call(stack.querySelectorAll('.ch-v449'), function (p) {
      panels[p.getAttribute('data-variant')] = p;
    });

    function show(name) {
      if (!panels[name]) return;
      Object.keys(panels).forEach(function (k) {
        panels[k].classList.toggle('ch-on', k === name);
      });
    }
    show('greens');                                     // default state

    /* desktop only: hovering a 448 product — its label OR its artwork — crossfades
       449 to that variant. Mobile shows greens alone, so it is skipped there. */
    [].forEach.call(document.querySelectorAll('#cloud-products [data-cons]'), function (a) {
      a.addEventListener('mouseenter', function () {
        if (matchMedia('(max-width:1100px)').matches) return;
        show(a.getAttribute('data-cons'));
      });
    });



  })();


  /* ---- 446 product picker: Collagen / Superfoods toggle ----
     Copy is taken from the product artwork itself, not invented: the Superfoods
     pouch reads "Daily Superfood Gummies / 36+ Greens & Superfoods | 28-day supply"
     with a WILD STRAWBERRY flavour chip. */
  (function () {
    var sec = document.getElementById('cloud-picker');
    if (!sec) return;

    /* variant data comes from data-* on the toggle links, which the section renders
       from its settings — so a merchant edit in Customise is picked up here. */
    function readVariant(a) {
      return { title:a.getAttribute('data-title'), flavour:a.getAttribute('data-flavour'),
               badge:a.getAttribute('data-badge'), href:a.getAttribute('data-href'),
               body:(a.getAttribute('data-body')||'').split('|') };
    }
    var links = [].slice.call(sec.querySelectorAll('a.ch-grmnd'));
    var title = sec.querySelector('.ch-pk-title');
    var chip  = sec.querySelector('.ch-pk-flavour');
    var badge = sec.querySelector('.ch-badge');
    var body  = sec.querySelector('.ch-pk-body');
    var cta   = sec.querySelector('.ch-pk-cta');

    function select(name) {
      var src = links.filter(function (a) { return a.getAttribute('data-variant') === name; })[0];
      if (!src) return;
      var v = readVariant(src);
      sec.setAttribute('data-variant', name);
      title.textContent = v.title;
      chip.textContent  = v.flavour;
      badge.style.background = v.badge;
      body.innerHTML = v.body.join('<br>');
      cta.setAttribute('href', v.href);
      links.forEach(function (a) {
        var on = a.getAttribute('data-variant') === name;
        a.classList.toggle('ch-sel', on);
        if (on) a.setAttribute('aria-current', 'true');
        else    a.removeAttribute('aria-current');
      });
    }

    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        select(a.getAttribute('data-variant'));
      });
    });
  })();

  /* ---- Shop All: filter tabs ----
     Hides the product that doesn't match and slides the dot to the active word.
     "all" clears the filter. No-ops on pages without the tabs. */
  (function () {
    var tabs = [].slice.call(document.querySelectorAll('.ch-sa-tab'));
    var row  = document.getElementById('cloud-shopall-products');
    if (!tabs.length || !row) return;
    var dot = document.querySelector('.ch-sa-dot');

    function apply(which, tab) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('ch-sa-on', on);
        if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      /* tabs are centre-anchored by .ch-cx, so a tab's own `left` IS its centre —
         offset by half the 14px dot */
      if (dot) dot.style.left = (parseFloat(tab.style.left) - 7) + 'px';
      row.classList.toggle('ch-sa-filtered', which !== 'all');
      [].forEach.call(row.querySelectorAll('[data-cons]'), function (el) {
        el.classList.toggle('ch-sa-show', which === 'all' || el.getAttribute('data-cons') === which);
      });
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function (e) { e.preventDefault(); apply(t.getAttribute('data-filter'), t); });
    });
  })();

